<template>
  <v-flex md12>
    <kendo-grid
      height="calc(100vh - 132px)"
      :dataSource="dataSource"
      :editable="!isReadOnly && 'inline'"
      :toolbar="!isReadOnly ? ['create'] : []"
      ref="grid"
      :filterable="true"
      :sortable="true"
      :pageable-always-visible="true"
      :data-source="this.dataSource"
      :columns="columns"
    >
    </kendo-grid>
  </v-flex>
</template>

<script>
import {getDataItem} from '@/helpers/kendo-helpers'
import {enableExportExcel} from '@/helpers/export-helper'
import {readOnlyEditor, numericEditor} from '@/helpers/kendo-editors'
import security from '@/mixins/security'

const $ = kendo.jQuery

export default {
  name: 'FxVolatilityCurves',
  mixins: [security],
  mounted() {
    const grid = this.$refs.grid.kendoWidget()
    enableExportExcel(grid, '/api/config/volatilityCurves/exportToExcel')
  },
  data() {
    return {
      dataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 30,
        transport: {
          read: {
            type: 'GET',
            url: '/api/config/volatilityCurves',
            dataType: 'json',
          },
          create: {
            type: 'POST',
            url: '/api/config/volatilityCurves',
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/config/volatilityCurves',
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/config/volatilityCurves',
            dataType: 'json',
          },
        },
        requestEnd: e => {
          if (e.type == 'update' || e.type == 'create') {
            this.$refs.grid.kendoWidget().dataSource.read()
          }
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'curveId',
            fields: {
              curveId: {type: 'number', defaultValue: 0},
              code: {type: 'string', validation: {required: true}},
              pointValue: {type: 'number', defaultValue: 0.0001, editable: true},
              canDelete: {type: 'boolean', defaultValue: true},
            },
          },
        },
      }),
    }
  },
  computed: {
    columns() {
      return [
        {
          editable: !this.isReadOnly,
          command: [{name: 'edit'}],
          width: 61,
        },
        {
          field: 'code',
          title: 'Ccy Pair',
          width: 114,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor: this.codeEditor,
          template: '#=code#',
        },
        {
          field: 'pointValue',
          title: 'FX Point Value',
          width: 132,
          format: '{0:n4}',
          attributes: {style: 'text-align: right;'},
          editor: this.pointValueNumericEditor,
        },
        {
          command: [{name: 'destroy', visible: dataItem => dataItem.canDelete}],
          width: 61,
          attributes: {style: 'text-align: center;'},
          hidden: this.isReadOnly,
        },
        {},
      ].filter(c => c.editable !== false)
    },
  },
  methods: {
    codeEditor(container, options) {
      if (options.model.curveId > 0) {
        return readOnlyEditor.call(this, container, options)
      }

      let grid = this.$refs.grid.kendoWidget()
      let gridDataItem = grid.dataItem(container.closest('tr'))
      let textField = 'code'
      let valueField = 'ccyPairId'
      let usesValidation = true

      const defaultOptions = {
        filter: 'contains',
        template: '<span>${' + textField + '}</span>',
        change: e => {
          let dataItem = getDataItem(e.sender.element)
          gridDataItem.set('ccyPairId', dataItem.ccyPairId.ccyPairId)
        },
        dataSource: {
          transport: {
            read: {
              url: '/api/config/volatilityCurves/getVolatilityCurveCodes',
              contentType: 'application/json',
              type: 'GET',
            },
          },
        },
      }

      const input = `<input ${usesValidation ? 'required' : ''}
                      id="${options.field}"
                      name="${options.field}"
                      data-text-field="${textField}"
                      data-value-field="${valueField}"
                      data-bind="value: ${textField == valueField ? options.field : valueField}"/>`
      $(input)
        .appendTo(container)
        .kendoDropDownList({
          ...defaultOptions,
        })

      if (usesValidation) {
        $(`<span class="k-invalid-msg" data-for="${options.field}"></span>`).appendTo(container)
      }
    },
    pointValueNumericEditor(container, options) {
      return numericEditor({
        format: 'n4',
        decimals: 6,
        min: 0,
        spinners: false,
        step: 0,
      }).call(this, container, options)
    },
  },
}
</script>
